import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalWrapper from 'components/shared/ModalWrapper';
import Text from 'components/shared/Text';
import { SLIPPAGE_LIMIT } from './slippage';

const toPercentage = num => num * 100;

function ModalSlippageWarning({ handleClose, handleSubmit, isMobile }) {
  const { t } = useTranslation();
  return (
    <ModalWrapper
      buttonText={t('market_modal_slip_place_anyway')}
      cancelButtonText={t('market_modal_slip_go_back')}
      headerText={t('market_modal_slip_market_warning')}
      handleSubmit={handleSubmit}
      handleClose={handleClose}>
      <Text tag="p" muted centered={isMobile}>
        {t('market_modal_slip_u_sure')}
      </Text>
      <Text tag="p" muted centered={isMobile}>
        {t('market_modal_slip_due_price_volat', { slippageLimit: toPercentage(SLIPPAGE_LIMIT) })}
      </Text>
      <Text tag="p" muted centered={isMobile}>
        {t('market_modal_slip_please_consider')}
      </Text>
      <br />
      <br />
    </ModalWrapper>
  );
}

ModalSlippageWarning.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export default ModalSlippageWarning;
